import AgoraRTC from "agora-rtc-sdk-ng";
// 开启日志上传功能
AgoraRTC.enableLogUpload();
// 将日志输出级别设置为 INFO
AgoraRTC.setLogLevel(0);
import store from "@/store";

//对字符串进行加密
function compileStr(code) {
    var c = String.fromCharCode(code.charCodeAt(0) + code.length);
    for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
    }
    return escape(c + "leapin");
}
//字符串进行解密
function uncompileStr(code) {
    if (!code) return code;
    code = unescape(code);
    code = code.substr(0, code.length - 6);
    var c = String.fromCharCode(code.charCodeAt(0) - code.length);
    for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
}
// get url query
export function getQueryString(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}
export function CopyToClipboard(clipBoardContent) {
    return new Promise((resolve, reject) => {
        let textArea = document.createElement("textarea");
        textArea.style.position = "fixed";
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = "2em";
        textArea.style.height = "2em";
        textArea.style.padding = 0;
        textArea.style.border = "none";
        textArea.style.outline = "none";
        textArea.style.boxShadow = "none";
        textArea.style.background = "transparent";
        textArea.value = clipBoardContent;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
            resolve(true);
        } catch (err) {
            reject(false);
        }
        document.body.removeChild(textArea);
    });
}
export function SetStorage(key, value) {
    localStorage.setItem(key, compileStr(JSON.stringify(value)));
}
//获取localStorage
export function GetStorage(key) {
    return JSON.parse(uncompileStr(localStorage.getItem(key)));
}
export function getJugeWebsiteUrl(url) {
    const exp = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
    const objExp = new RegExp(exp);
    if (objExp.test(url) == true) {
        return url;
    } else {
        return `//${url}`;
    }
}
export function getBrowserType() {
    var userAgent = navigator.userAgent;
    var browser = 'unknown';
    if (userAgent.indexOf("IE") != -1) {
        browser = "IE";
    } else if (userAgent.indexOf('Firefox') != -1) {
        browser = "Firefox";
    } else if (userAgent.indexOf('OPR') != -1) {
        browser = "Opera";
    } else if (userAgent.indexOf('Chrome') != -1) {
        browser = "Chrome";
    } else if (userAgent.indexOf('Safari') != -1) {
        browser = "Safari";
    } else if (userAgent.indexOf('Trident') != -1) {
        browser = 'IE 11';
    }
    return browser;
}
export function getUserMedia(obj, success, error) {
    if (navigator.getUserMedia) {
        getUserMedia = (obj, success, error) => {
            navigator.getUserMedia(obj, (stream) => {
                success(stream);
            }, error);
        }
    } else if (navigator.webkitGetUserMedia) {
        getUserMedia = (obj, success, error) => {
            navigator.webkitGetUserMedia(obj, (stream) => {
                success(stream);
            }, error);
        }
    } else if (navigator.mozGetUserMedia) {
        getUserMedia = (obj, success, error) => {
            navigator.mozGetUserMedia(obj, (stream) => {
                success(stream);
            }, error);
        }
    } else if (navigator.mediaDevices.getUserMedia) {
        getUserMedia = (obj, success, error) => {
            navigator.mediaDevices.getUserMedia(obj).then((stream) => {
                success(stream);
            }).catch(error)
        }
    } else {
        return false;
    }
    return getUserMedia(obj, success, error);
}
export const videoRecorder = {
    localMediaRecorder: null,
    mediaStream: null,
    start: function (videoEle) {
        return new Promise((resolve, reject) => {
            store.commit("SET_ISALLOWVIDEO", false)
            getUserMedia({
                video: {
                    frameRate: { ideal: 5, max: 5 },
                    width: { min: 640, ideal: 1280 },
                    height: { min: 360, ideal: 720 },
                    aspectRatio: 16 / 9,
                    facingMode: "user",
                }, audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: true,
                },
            }, (stream) => {
                console.log(stream)
                store.commit("SET_ISALLOWVIDEO", true)
                this.mediaStream = stream
                videoEle.srcObject = stream;
                videoEle.play()
                const options = {
                    audioBitsPerSecond: 64000,
                    videoBitsPerSecond: 600000,
                    mimeType: getBrowserType() === "Safari" ? "video/mp4" : "video/webm"
                }
                store.commit("SET_MINE_TYPE", options.mimeType)
                this.localMediaRecorder = new MediaRecorder(stream, options)
                const chunks = [];
                this.localMediaRecorder.onstop = () => {
                    resolve(chunks)
                }
                this.localMediaRecorder.ondataavailable = (e) => {
                    chunks.push(e.data);
                };
                this.localMediaRecorder.start()
            }, () => {
                reject()
            });
        })
    },
    stop: function () {
        this.localMediaRecorder.stop();
        this.mediaStream.getTracks().forEach((track) => {
            track.stop();
        });
    }
}
export function isInViewPort(element) {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;
    const {
        top,
        right,
        bottom,
        left,
    } = element.getBoundingClientRect();
    return (
        top >= 0 &&
        left >= 0 &&
        right <= viewWidth &&
        bottom <= viewHeight
    );
}
export function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    })
};
export function toFullVideo(videoDom) {
    if (videoDom.requestFullscreen) {
        return videoDom.requestFullscreen();
    } else if (videoDom.webkitRequestFullScreen) {
        return videoDom.webkitRequestFullScreen();
    } else if (videoDom.mozRequestFullScreen) {
        return videoDom.mozRequestFullScreen();
    } else {
        return videoDom.msRequestFullscreen();
    }
}
export function isWechat() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
}
export function isWebview() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger" || ua.match(/alibaba/i) == "alibaba";
}
export function isStartByStr(str, startStr) {
    return str.indexOf(startStr) === 0;
}
export function getUuiD(randomLength) {
    return Number(Math.random().toString().substr(2, randomLength) + Date.now()).toString(36);
}

let agoraClient = null;
const agoraLocalTracks = {
    audioTrack: null,
    videoTrack: null
};
export async function createAgoraPublish(AppId, channel, token, uid, localPlayerEle, success, error) {
    store.commit("SET_ISALLOWVIDEO", false);
    agoraClient = AgoraRTC.createClient({
        codec: "vp8",
        mode: "live",
    });
    // 设置视频编码配置
    // const videoEncoderConfig = {
    //     width: 360, // 视频编码分辨率宽度
    //     height: 280, // 视频编码分辨率高度
    // };
    // // 应用视频编码配置
    // agoraClient.setVideoEncoderConfiguration(videoEncoderConfig);
    agoraClient.setClientRole("host");
    let joinUid = null;
    [joinUid, agoraLocalTracks.audioTrack, agoraLocalTracks.videoTrack] = await Promise.all([
        // join the channel
        agoraClient.join(AppId, channel, token, uid).catch(() => { }),
        // create local tracks, using microphone and camera
        AgoraRTC.createMicrophoneAudioTrack().catch(() => { }),
        AgoraRTC.createCameraVideoTrack().catch(() => { }),
    ]);
    if (!joinUid || !agoraLocalTracks.audioTrack || !agoraLocalTracks.videoTrack) {
        error();
        return;
    }
    // play local video track
    agoraLocalTracks.videoTrack.play(localPlayerEle);

    agoraClient.publish(Object.values(agoraLocalTracks)).then(() => {
        store.commit("SET_ISALLOWVIDEO", true);
        console.log("publish success");
        success();
    }).catch(() => {
        error();
    });
}
export async function handleAgoraChanelLeave(localPlayerEle) {
    if (agoraLocalTracks.audioTrack && agoraLocalTracks.videoTrack) {
        await agoraClient.unpublish(Object.values(agoraLocalTracks));
        agoraLocalTracks.videoTrack.stop(localPlayerEle);
        agoraLocalTracks.videoTrack.close();
        agoraLocalTracks.audioTrack.close();
    }
    if (agoraClient) {
        await agoraClient.leave();
    }
}

const imgPreloader = url => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.onload = () => {
            resolve();
        };
        image.onerror = () => {
            reject();
        };
    });
};
export const imgsPreloader = imgs => {
    const promiseArr = [];
    imgs.forEach(element => {
        promiseArr.push(imgPreloader(element));
    });
    return Promise.all(promiseArr);
};